<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row no-gutter justify-center items-center">
						<div class="vx-col hidden lg:block lg:w-1/2">
							<img
								src="@/assets/images/logo/logo-serviroute-2.png"
								alt="login"
								class="mx-auto img-serviroute"
								:style="`width:${result}px; top: ${top}%; left: ${left}%; position:${position};`"
							/>
							<transition name="bounce">
								<div v-if="showBrand" class="text-center">
									<img :src="companyBrand" alt="login" class="mx-auto img-company-brand" />
									<h1 class="mt-2 font-bold">{{ companyName }}</h1>
								</div>
							</transition>
						</div>

						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<div class="px-8 pt-8 login-tabs-container">
								<div class="vx-card__title mb-4">
									<h4 class="mb-4">ServiRoutes {{ companyNameTitle }}</h4>
									<p>{{ $t("Login.Subtitle") }}</p>
								</div>

								<vs-tabs>
									<vs-tab :label="$t('Login.Login')">
										<login-firebase
											:updateCompanyBrand="updateCompanyBrand"
											:resetAnimation="resetAnimation"
										></login-firebase>
									</vs-tab>
								</vs-tabs>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import LoginJwt from "./LoginJWT.vue";
import LoginFirebase from "./LoginFirebase.vue";

export default {
	components: {
		LoginJwt,
		LoginFirebase,
	},
	data() {
		return {
			showBrand: false,
			result: 400,
			top: 0,
			left: 0,
			position: "relative",
			companyBrand: require("@/assets/images/pages/1-apex.png"),
			companyName: "",
		};
	},
	computed: {
		companyNameTitle() {
			return this.companyName ? "/ " + this.companyName : "";
		},
	},
	methods: {
		updateCompanyBrand({text, url_logo}) {
			if (!url_logo) return;
			this.companyBrand = url_logo;
			this.companyName = text ? text : "";
			this.runAnimation();
			setTimeout(() => {
				this.showBrand = true;
				this.position = "absolute";
			}, 700);
		},
		openLoading() {
			this.$vs.loading();
		},
		runAnimation() {
			this.result = 70;
			this.top = 5;
			this.left = 5;
		},
		resetAnimation() {
			this.companyName = "";
			this.showBrand = false;
			setTimeout(() => {
				this.result = 400;
				this.top = 0;
				this.left = 0;
				this.position = "relative";
			}, 700);
		},
	},
};
</script>

<style lang="scss">
.login-tabs-container {
	min-height: 505px;

	.con-tab {
		padding-bottom: 14px;
	}

	.con-slot-tabs {
		margin-top: 1rem;
	}
}

.img-serviroute {
	width: 100px;
	height: auto;
	transition: width 2s, top 1s, left 1s, position 1s;
}

.img-company-brand {
	width: 390px;
}

.bounce-enter-active {
	animation: bounce-in 1s;
}
.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.25);
	}
	100% {
		transform: scale(1);
	}
}
</style>
